import React from "react";
import Usp from "../../Components/Usp/Usp";
import MoreFeatures from "../../Components/MoreFeatures/MoreFeatures";
import Footer from "../../Components/Footer/Footer";
import "./CountryPage.css";
import HeroPostLaunch from "../../Components/HeroPostLaunch/HeroPostLaunch";
import DownloadTile from "../../Components/DownloadTile/DownloadTile";

export type TranslationsMap = {
  [key: string]: string;
};

export type AssetsTranslations = {
  firstSectionMobile: string;
  firstSectionDesktop: string;
  secondSectionMobile: string;
  secondSectionDesktop: string;
  thirdSectionMobile: string;
  thirdSectionDesktop: string;
  fourthSectionMobile: string;
  fourthSectionDesktop: string;
};

interface CountrySelectionProps {
  translations: TranslationsMap;
  assets: AssetsTranslations;
  showSponsor?: boolean;
}

const CountryPage: React.FC<CountrySelectionProps> = ({
  translations,
  assets,
}) => {
  return (
    <div>
      <div className="country-page-container">
        <div className="large-layout">
          <div className="country-page-list-view">
            <HeroPostLaunch translations={translations} />
            <Usp
              label={translations["landingPage.usp.ho.label"]}
              title={translations["landingPage.usp.ho.title"]}
              description={translations["landingPage.usp.ho.body"]}
              imageSrcMobile={assets.firstSectionMobile}
              imageSrcDesktop={assets.firstSectionDesktop}
              mobileBgColor="#FACB94"
            />
            <Usp
              label={translations["landingPage.usp.ia.label"]}
              title={translations["landingPage.usp.ia.title"]}
              description={translations["landingPage.usp.ia.body"]}
              imageSrcMobile={assets.secondSectionMobile}
              imageSrcDesktop={assets.secondSectionDesktop}
              mobileBgColor="#FFFFFF"
              alignment="right"
            />
            <Usp
              label={translations["landingPage.usp.si.label"]}
              title={translations["landingPage.usp.si.title"]}
              description={translations["landingPage.usp.si.body"]}
              imageSrcMobile={assets.thirdSectionMobile}
              imageSrcDesktop={assets.thirdSectionDesktop}
              mobileBgColor="#FACB94"
            />
            <div className="display-desktop">
              <Usp
                label={translations["landingPage.usp.cs.label"]}
                title={translations["landingPage.usp.cs.title"]}
                description={translations["landingPage.usp.cs.body"]}
                imageSrcMobile={assets.fourthSectionMobile}
                imageSrcDesktop={assets.fourthSectionDesktop}
                alignment="right"
                mobileBgColor="#FFFFFF"
              />
            </div>
            <MoreFeatures translations={translations} />
            <DownloadTile translations={translations} />
            <Footer translations={translations} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryPage;
